import React, {useEffect, useState} from "react"
import {useNavigate} from "react-router"
import {useDroneEvent} from "@murphy-frontend/common/api/DroneEvents/Queries"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import {FunctionComponent} from "react"
import {useParams} from "react-router-dom"
import ComponentWrapper from "../../../common/components/ComponentWrapper"
import StartedEventFlowTabs from "../components/StartedEventFlowTabs"
import {MurphyOpenedDroneEventDto} from "@murphy-frontend/common/interfaces/IDroneEventsApi"
import Button from "@murphy-frontend/web-core/components/Button"
import {IoChevronBackOutline} from "react-icons/io5"
import {IconContext} from "react-icons/lib"
import StatusCard from "../components/StatusCard"
import EventMap from "../components/EventMap"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

interface StartedEventFlowPageProps {}

const StartedEventFlowPage: FunctionComponent<StartedEventFlowPageProps> = () => {
	const [eventData, setEventData] = useState<MurphyOpenedDroneEventDto>()
	const {id} = useParams()
	const {translations} = useUserPreferences()
	const navigate = useNavigate()
	const {
		data: startedEventFlow,
		isLoading: startedEventFlowIsLoading,
		isPending: startedEventFlowIsPending
	} = useDroneEvent(parseInt(id))

	useEffect(() => {
		if (!startedEventFlowIsLoading) setEventData(startedEventFlow)
	}, [startedEventFlowIsPending, startedEventFlow, startedEventFlowIsLoading])

	if (startedEventFlowIsLoading || !startedEventFlow || !eventData) {
		return (
			<ComponentWrapper active={6}>
				<Spinner isGlobal />
			</ComponentWrapper>
		)
	}

	return (
		<ComponentWrapper active={6}>
			<section className='header-btns'>
				<div className='header-back-btn'>
					<Button
						buttonSize={"btn--medium"}
						isLightButton={true}
						onClick={() => navigate("/startedeventflows")}
					>
						<IconContext.Provider value={{className: "btn-icon"}}>
							<IoChevronBackOutline />
						</IconContext.Provider>
						{translations.back}
					</Button>
				</div>
			</section>
			<section className='header-btns'>
				<div className='header-back-btn'>
					<h2>{startedEventFlow.Title}</h2>
				</div>
				{startedEventFlow.Completed && (
					<div className='header-right-btn event-completed-text'>
						<em>{translations.incidentClosedText}</em>
					</div>
				)}
			</section>
			<section className='event-container-general'>
				{!!startedEventFlow.Tabs.length && (
					<StartedEventFlowTabs
						tabs={[...eventData.Tabs]}
						droneId={parseInt(id)}
						isCompleted={eventData.Completed}
					/>
				)}
				<div className='event-history-card'>
					<div className='card-container event-history-ph'>
						<StatusCard
							steps={eventData.Timeline}
							history={eventData.History}
							eventFlowHistory={eventData.StartedEventFlowHistory}
							latitude={startedEventFlow.Latitude}
							longitude={startedEventFlow.Longitude}
						/>
					</div>
					<div className='card-container event-history-ph'>
						<EventMap steps={eventData.Timeline} />
					</div>
				</div>
			</section>
		</ComponentWrapper>
	)
}

export default StartedEventFlowPage
